import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=80b18e98&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=ts"
export * from "./NotFound.vue?vue&type=script&lang=ts"
import style0 from "./NotFound.vue?vue&type=style&index=0&id=80b18e98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b18e98",
  null
  
)

export default component.exports